import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CarCounterStoreService {
  private readonly IS_ACTIVE = new BehaviorSubject<boolean>(false);
  readonly isActive$ = this.IS_ACTIVE.asObservable();

  get isActive(): boolean {
    return this.IS_ACTIVE.getValue();
  }
  set isActive(value: boolean) {
    this.IS_ACTIVE.next(value);
  }

  laneType: 'entry' | 'exit' | 'transfer' | null = null;
  laneName = '';
  toGroupId: number | null = null;
  fromGroupId: number | null = null;
  positionGroupId: number | null = null;
  deviceId = '';
  zoneId: number | null = null;

  reset() {
    this.isActive = false;
    this.laneType = null;
    this.laneName = '';
    this.toGroupId = null;
    this.fromGroupId = null;
    this.positionGroupId = null;
    this.deviceId = '';
    this.zoneId = null;
  }
}
